import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLink, useSetLink } from '../state';
import Logout from './auth/Logout';
import fetchWithToken from '../services';
import { FaEye, FaPalette, FaChartBar } from 'react-icons/fa6';
import { FaHome, FaCog } from 'react-icons/fa';

const Sidebar = ({ onItemClick }) => {
  const navigate = useNavigate();
  const link = useLink();
  const setLink = useSetLink();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [activePage, setActivePage] = React.useState(() => {
    // Determine initial active page based on current path
    const path = window.location.pathname;
    if (path === '/' || path === '/account') return 'Home';
    if (path === '/settings') return 'Settings';
    if (path === '/analytics') return 'Analytics';
    if (path === '/customize') return 'Customize';
    return '';
  });

  const getLink = async () => {
    try {
      const res = await fetchWithToken('/get-link-id');

      if (!res.ok) {
        throw new Error(`Failed to fetch link ID: ${res.status}`);
      }

      const data = await res.json();
      const { linkId } = data;
      const link = `${baseUrl}/${linkId}`;
      setLink(link);
    } catch (err) {
      console.error('Error fetching link ID:', err);
    }
  }

  useEffect(() => {
    if (!link) {
      getLink();
    }
  }, [link]);

  const handleMenuClick = (itemName) => {
    // Set the active page (except for View page which opens in new tab)
    if (itemName !== 'View page') {
      setActivePage(itemName);
    }

    if (itemName === 'Home') {
      navigate('/account');
    } else if (itemName === 'View page' && link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    } else if (itemName === 'Settings') {
      navigate('/settings');
    } else if (itemName === 'Analytics') {
      navigate('/analytics');
    } else if (itemName === 'Customize') {
      navigate('/customize');
    }

    // Close sidebar on mobile when an item is clicked
    if (onItemClick) {
      onItemClick();
    }
    // Other navigation options can be added here later
  };

  const menuItems = [
    { name: 'Home', icon: <FaHome size={20} color="white" /> },
    { name: 'View page', icon: <FaEye size={20} color="white" /> },
    { name: 'Customize', icon: <FaPalette size={20} color="white" /> },
    { name: 'Analytics', icon: <FaChartBar size={20} color="white" /> },
    { name: 'Settings', icon: <FaCog size={20} color="white" /> }
  ];

  return (
    <div className="fixed left-0 top-0 h-full w-full md:w-48 bg-[#68C7CC] z-20 flex flex-col font-sans overflow-y-auto">
      {/* Flex container for vertical centering */}
      <div className="flex-grow flex flex-col justify-center">
        {/* Menu items */}
        <ul className="space-y-6 px-6 md:px-6 mx-auto w-full max-w-44 md:max-w-none">
          {/* Menu options */}
          {menuItems.map((item, index) => (
            <li key={index}>
              <button
                className={`w-full text-white flex md:items-start items-center justify-center md:justify-start py-4 px-3 rounded-lg transition-all duration-200 ${activePage === item.name ? 'bg-[#4A9A9F]' : 'hover:bg-[#4A9A9F]/70'}`}
                onClick={() => handleMenuClick(item.name)}
              >
                <span className="md:mr-3 mr-2 flex items-center justify-center">{item.icon}</span>
                <span className="font-medium">{item.name}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* Logout button for mobile - positioned at bottom */}
      <div className="md:hidden w-full max-w-44 flex items-center justify-center mt-auto mb-20 mx-auto">
        <Logout />
      </div>
    </div>
  );
};

export default Sidebar;
